var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 2C4.89543 2 4 2.89543 4 4V18C4 19.1046 4.89543 20 6 20H16C17.1046 20 18 19.1046 18 18V8.25H13.7143C12.6097 8.25 11.7143 7.35457 11.7143 6.25V2H6ZM13.7143 3.40452L16.576 6.25H13.7143V3.40452ZM2 4C2 1.79086 3.79086 0 6 0H12.7143C12.9785 0 13.232 0.104576 13.4194 0.290882L19.7051 6.54088C19.8939 6.72858 20 6.9838 20 7.25V18C20 20.2091 18.2091 22 16 22H6C3.79086 22 2 20.2091 2 18V4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.60ad040f925d84027ea91a44c0c84093.svg";
export { ForwardRef as ReactComponent };